// Event routes (GPX courses): how they're drawn and described, shared by the
// Event dialog's route list, the incidents map and the weather safety beta.
// DOM-free on purpose, like incidentMap.js.

// Each route gets a colour AND a dash pattern by its position in the event's
// list, so two routes can be told apart without relying on hue — the map's rule
// that nothing is said by colour alone. The hues avoid the location dots' own
// (LOCATION_TYPE_COLOR), since lines and dots share the map.
export const ROUTE_COLORS = ["#d81b60", "#3949ab", "#f9a825", "#00acc1", "#7cb342", "#5e35b1"];
export const ROUTE_DASHES = [null, "10 6", "2 6", "12 5 2 5"];

// Colour and dash both step with the index (6 × 4 → 12 distinct pairs before
// one repeats), so neighbouring routes in the list always differ in both.
export const routeStyle = (index) => ({
  color: ROUTE_COLORS[index % ROUTE_COLORS.length],
  dashArray: ROUTE_DASHES[index % ROUTE_DASHES.length],
});

const TZ = "Europe/London";

export const fmtRouteTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-GB", {
    timeZone: TZ, weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
  }) : null;

// "Sat 3 Oct 09:00 – 15:00", or across days "Sat 3 Oct 09:00 – Sun 4 Oct 12:00".
export function fmtRouteWindow(route) {
  const s = fmtRouteTime(route.start_at);
  const c = route.close_at ? new Date(route.close_at) : null;
  if (!s && !c) return "No times set";
  if (!c) return `Starts ${s}`;
  if (!s) return `Closes ${fmtRouteTime(route.close_at)}`;
  const sameDay = new Date(route.start_at).toLocaleDateString("en-GB", { timeZone: TZ })
    === c.toLocaleDateString("en-GB", { timeZone: TZ });
  const end = sameDay
    ? c.toLocaleTimeString("en-GB", { timeZone: TZ, hour: "2-digit", minute: "2-digit" })
    : fmtRouteTime(route.close_at);
  return `${s} – ${end}`;
}

// "13.6 km · 970 m ascent · high point 1086 m" — whatever the file supports.
export function routeFigures(route) {
  const parts = [];
  if (route.distance_km != null) parts.push(`${route.distance_km.toFixed(1)} km`);
  if (route.ascent_m != null) parts.push(`${Math.round(route.ascent_m)} m ascent`);
  if (route.max_elevation_m != null) parts.push(`high point ${Math.round(route.max_elevation_m)} m`);
  if (route.ascent_m == null && route.distance_km != null) parts.push("no elevation in file");
  return parts.join(" · ");
}

// Minutes as "1 h 25 min" / "40 min".
export function fmtMinutes(min) {
  if (min === null || min === undefined) return "—";
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  return h ? `${h} h${m ? ` ${m} min` : ""}` : `${m} min`;
}
